import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {hostNameValidator} from '../../../../validators/host-name-validator.directive';
import {RdapServersValidatorService} from '../../../../validators/service/rdap-servers-validator.service';
import {ValidatorService} from '../../../../services/validator.service';
import {ServerConstants} from '../../../../model/ServerConstants';
import {ValueFromAdditionalMapPipe} from '../../../../pipes/value-from-additional-map.pipe';
import {RdapServerVO, TopLevelDomainVO} from '../../../../generate/TopLevelDomainVO';
import {UtilService} from '../../../../util/util.service';
import {ErrorVO} from '../../../../generate/ErrorVO';
import {urlValidator} from '../../../../validators/url-validator.directive';

@Component({
  selector: 'sub-domain-info-edit',
  templateUrl: './sub-domain-info-edit.component.html',
  styleUrls: ['./sub-domain-info-edit.component.scss']
})
export class SubDomainInfoEditComponent implements OnInit {
  @Input()
  newDelegation: boolean;
  @Input()
  domain: TopLevelDomainVO;
  editSubDomainInfoForm: FormGroup;
  @Output()
  domainVOOutPut = new EventEmitter<TopLevelDomainVO>();
  @Output()
  cancelOutPut = new EventEmitter<boolean>();
  modifiedRDAPServers: Array<RdapServerVO>;
  rdapErrors: Array<string> = [];
  errors: ErrorVO;
  ignoreRegistrySSLError: boolean;
  ignoreRDAPError: boolean;
  loadingData: boolean;
  serverConstants = ServerConstants;
  interfaceType: string;

  constructor(private formBuilder: FormBuilder, private util: UtilService, private validatorService: RdapServersValidatorService, private  validator: ValidatorService, @Inject('env') private environment) {
  }

  ngOnInit() {
    this.interfaceType = this.environment.config.interfaceType;
    this.ignoreRegistrySSLError = false;
    this.ignoreRDAPError = false;
    this.modifiedRDAPServers = this.util.cloneArray(this.domain.rdapServers);
    this.createForm(this.domain.registryUrl, this.domain.whois);

  }

  onSubmit() {
    this.loadingData = true;
    const formValue = this.editSubDomainInfoForm.getRawValue();
    const submittingDomain: TopLevelDomainVO = Object.create(this.domain);
    submittingDomain.registryUrl = this.util.returnNullIfEmpty(formValue.registrationurl);
    submittingDomain.whois = this.util.returnNullIfEmpty(formValue.whoisserver);
    submittingDomain.rdapServers = this.modifiedRDAPServers;
    submittingDomain.status = this.domain.status;
    submittingDomain.name = this.domain.name;

    if (this.domain.status === 'Inactive') {
      submittingDomain.name = this.domain.name;
      submittingDomain.nameServers = this.domain.nameServers;
    }

    submittingDomain.ignoreRegistrySSLError = this.ignoreRegistrySSLError;
    submittingDomain.ignoreRDAPError = this.ignoreRDAPError;
    this.validator.validateAdditionalInfo(this.domain, submittingDomain).subscribe(data => {
      if (data == null) {
        this.domain.registryUrl = submittingDomain.registryUrl;
        this.domain.whois = submittingDomain.whois;
        this.domain.rdapServers = this.modifiedRDAPServers;
        this.domain.ignoreRegistrySSLError = submittingDomain.ignoreRegistrySSLError;
        this.domain.ignoreRDAPError = submittingDomain.ignoreRDAPError;
        this.domainVOOutPut.emit(this.domain);
      } else {
        this.errors = data;
        if(this.interfaceType === "STAFF"){
          if (!this.ignoreRegistrySSLError) {
            this.ignoreRegistrySSLErrors(this.errors);
          }

          if (!this.ignoreRDAPError) {
            this.ignoreRDAPErrors(this.errors);
          }
        }

      }
    }, () => {
      this.loadingData = false;

    }, () => {

      this.loadingData = false;

    });

  }

  addAdditionalRdapServer() {
    const formValue = this.editSubDomainInfoForm.getRawValue();
    const rdapServer: RdapServerVO = {};
    rdapServer.url = formValue.rdapServer;
    const errors: Array<string> = this.validatorService.validateRdapServers(rdapServer, this.modifiedRDAPServers);
    if (errors.length > 0) {
      this.rdapErrors = errors;
    } else {
      this.addHttpAndwwwtoRdapServer(rdapServer);
      this.modifiedRDAPServers.push(rdapServer);
      this.createForm(formValue.registrationurl, formValue.whoisserver);
    }
  }

  public addHttpAndwwwtoRdapServer(rdapServer: RdapServerVO) {
    let url: string = rdapServer.url;
    if (url.indexOf('http') === -1) {
      url = 'http://' + url;
    }

    rdapServer.url = url;


  }

  removeRdapServer(i: number) {
    this.modifiedRDAPServers.splice(i, 1);
  }

  displayValidationError(controlName: string): boolean {
    return this.util.displayValidationError(this.editSubDomainInfoForm, controlName);
  }

  displayServerValidationError(field: string): string[] {
    const error: ErrorVO = this.util.getFieldError(field, this.errors);
    return this.buildErrorMessages(error);
  }

  checkForRDAPError(url: string): string[] {
    const error: ErrorVO = this.util.getFieldError(url, this.errors);
    return this.buildErrorMessages(error);
  }

  buildErrorMessages(error: ErrorVO): string[] {
    const errorMessages: string[] = [];

    if (error == null) {
      return errorMessages;
    }
    for (const err of error.errorMessages) {
      if (err === 'Invalid SSL certificate') {
        errorMessages.push('We notice that you are using a self signed or invalid SSL certificate. If you still wish to continue please click the "Save" button');
      } else {
        errorMessages.push(err);
      }
    }

    return errorMessages;
  }

  private createForm(registryURL, whois) {
    this.editSubDomainInfoForm = this.formBuilder.group({
      registrationurl: [{value: registryURL, disabled: this.isDisabled(ServerConstants.REGISTRYURL_FIELD_NAME)}, [urlValidator]],
      whoisserver: [{value: whois, disabled: this.isDisabled(ServerConstants.WHOIS_FIELD_NAME)}, [hostNameValidator]],
      rdapServer: [{value: '', disabled: this.isDisabled(ServerConstants.RDAP_SERVER_FIELD_NAME)}, [urlValidator]]
    });
    this.rdapErrors = [];
  }

  cancel() {
    this.cancelOutPut.emit(true);
  }

  private ignoreRegistrySSLErrors(errors: ErrorVO) {
    const registryErrors: ErrorVO = this.util.getFieldError(this.serverConstants.REGISTRYURL_FIELD_NAME, errors);
    this.ignoreRegistrySSLError = this.checkIfSSLException(registryErrors);
  }

  private ignoreRDAPErrors(errors: ErrorVO) {
    for (const rdap of this.modifiedRDAPServers) {
      const rdapError: ErrorVO = this.util.getFieldError(rdap.url.trim(), errors);
      if(rdapError){
        this.ignoreRDAPError = true;
      }
      if (this.ignoreRDAPError) {
        break;
      }
    }
  }

  private checkIfSSLException(error: ErrorVO): boolean {
    if (error == null) {
      return false;
    }

    let isSSLException = false;
    for (const message of error.errorMessages) {
      if (message && message.indexOf('Invalid SSL certificate') > -1) {
        isSSLException = true;
        break;
      }
    }
    return isSSLException;
  }

  isDisabled(type: string): boolean {
    console.log("hree")
    return !this.util.checkIfEmptyList(new ValueFromAdditionalMapPipe().transform(this.domain, ServerConstants.LOCK_FIELD_NAME, type));
  }
}
